import Image from "next/image";
import { isFestivePeriod } from "@/lib/utils/logo";

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function Logo({
  width = 40,
  height = 40,
  className = "",
  style,
}: LogoProps) {
  const isChristmas = isFestivePeriod();
  const logoSrc = isChristmas
    ? "/images/logo-christmas.svg"
    : "/images/logo.svg";
  const altText = isChristmas
    ? "Sell It Off Logo - Christmas Edition"
    : "Sell It Off Logo";
  return (
    <Image
      src={logoSrc}
      alt={altText}
      width={width}
      height={height}
      className={className}
      style={style}
    />
  );
}
